module.exports = __webpack_public_path__ + "img/0.9198326d.jpg";